/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Connect_LabelInputs */

const en_ui_intervals_connect_label = /** @type {(inputs: Ui_Intervals_Connect_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key`)
};

const de_ui_intervals_connect_label = /** @type {(inputs: Ui_Intervals_Connect_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Key`)
};

/**
* | output |
* | --- |
* | "API key" |
*
* @param {Ui_Intervals_Connect_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_connect_label = /** @type {((inputs?: Ui_Intervals_Connect_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Connect_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_connect_label(inputs)
	return de_ui_intervals_connect_label(inputs)
});